/* eslint-disable @typescript-eslint/ban-ts-comment */
import { canManageCrew, canManageDataImport, canManageWells } from './permission/Permissions'
import ServiceLocator from 'live/services/service-locator'
import { DataImportForm } from './tabs/DataImportForm'
import { Configuration } from './api'

export const config = new Configuration({
    basePath: '/services/plugin-csv-dataimport'
})

if (canManageDataImport() && canManageCrew()) {
    try {
        ServiceLocator.getService('asset-tab-service').then(service => {
            // @ts-ignore
            service.register({
                step: 'data-import',
                order: 101,
                assetType: 'crew',
                label: 'Data Import',
                shouldHide: false,
                body: DataImportForm
            })
        })
    } catch (e) {
        console.error('Error while creating data import tab:', e)
    }
}

if (canManageDataImport() && canManageWells()) {
    try {
        ServiceLocator.getService('asset-tab-service').then(service => {
            // @ts-ignore
            service.register({
                step: 'data-import',
                order: 101,
                assetType: 'wells',
                label: 'Data Import',
                shouldHide: false,
                body: DataImportForm
            })
        })
    } catch (e) {
        console.error('Error while creating data import tab:', e)
    }
}
